import React from 'react';

export const getPasswordRequirementsTooltip = (minLength = 16) => {
  return (
    <ul>
      <span>Must be:</span>
      <li>{minLength} chars long</li>
      <li>One upper char</li>
      <li>One lower char</li>
      <li>One special char</li>
      <li>One digit chars</li>
      <span>Supported chars: @, $, !, %, *, ?, &, #;</span>
    </ul>
  );
};
